import AgentCommissionLabel from './DealItemExperimental/AgentCommissionLabel'
import OfferCommissionControl from './DealItemExperimental/OfferCommissionControl';
import { t } from '../../utilities/translator';
import { useGetOffersByIdsQueryState, useGetProposalByIdQuery, useUpdateOfferCommissionMutation } from '../proposals/proposalsApi';
import { useParams } from 'react-router-dom';
import { User } from '../../types/user';
import { useAppSelector } from '../../hooks/hooks';
import { useEffect, useState } from 'react';
import { toast } from 'travelyo-react-shared-components';
import { getDisplayPrice } from '../../utilities/priceHelper';

type Props = {
  offer: any;
  stickers: any;
  type: string;
  offerPrice: string;
  crossoutPrice: React.ReactNode;
}

const ProposalDealFooter = (props: Props) => {
  const { offer, stickers, type, offerPrice, crossoutPrice } = props;
  const [updateOfferCommission, state] = useUpdateOfferCommissionMutation();
  const user = useAppSelector(state => state.user) as unknown as User;
  const { id } = useParams<{ id: string }>();
  const [isUpdatingOffer, setIsUpdatingOffer] = useState(false);

  const { data: proposal } = useGetProposalByIdQuery({ proposalId: Number(id), muid: user?.user?.muid || '' });
  const proposalOffersState = useGetOffersByIdsQueryState(proposal?.offers || [], Number(id));

  // Track if this specific offer is being updated
  useEffect(() => {
    if (state.isLoading) {
      setIsUpdatingOffer(true);
    } else if (isUpdatingOffer && !proposalOffersState.isFetching) {
      // Only clear the loading state if this offer was being updated
      setIsUpdatingOffer(false);
    }
  }, [state.isLoading, proposalOffersState.isFetching, isUpdatingOffer]);

  const onSave = (data: any, newTotalPrice: number) => {
    updateOfferCommission(data).unwrap().then(() => {
      let label = data.commission ? data.commission : proposal?.commission;
      if (user.userContextMetaData?.b2bDisplayProperties?.commission?.display) {
        label = t('proposals.offerCommissionUpdated', { value: `${label}%` });
      } else {
        label = t('proposals.offerPriceUpdated', { value: getDisplayPrice(newTotalPrice) });
      }
      toast(label, {
        className: 'voyage-toast',
        description: '',
        duration: 5000,
        icon: <i className="ri-check-line text-lg text-primary" />,
        position: 'bottom-center',
        cancel: <div className="voyage-toast-close cursor-pointer" onClick={() => toast.dismiss()}><i className="ri-close-line text-lg" /></div>
      });
    });
  }

  return (
    <div className="deal-footer flex justify-end gap-2 p-4">
      {!!(stickers?.crossOut?.percent && stickers?.crossOut?.percent > 3) && window.dataGlobalSettings.siteType !== 3 && crossoutPrice}

      {type === 'proposals-list' && window.location.href.indexOf('b2bcustomerview') === -1 && (
        <OfferCommissionControl offer={offer} onSave={onSave} />
      )}

      <div className="flex flex-col gap-1 items-end js-offer-price w-full" data-total-price={offer?.price}>
        <div className="flex gap-2 items-center w-full justify-between">
          {window.dataGlobalSettings.siteType === 3 && <AgentCommissionLabel />}
          <span className={`text-xl font-bold leading-none ms-auto ${isUpdatingOffer && 'animate-fade-in-out'}`}>{offerPrice}</span>
        </div>
        <span className="text-[10px] !font-medium leading-none">{t('dealItem.per_person')}</span>
      </div>
    </div>
  )
}

export default ProposalDealFooter
